import { RecordBase } from '../../providers/request/record-base.model';

export class ArchiveFileSummary extends RecordBase {
  fileCount?: number;
  filePageCount?: number;
  fileSize?: number;
  zipFileId?: string;
  signFileSize?: number;
  signFileCount?: number;
  signFilePageCount?: number;
  signFileRate?: number;
  printedFileCount?: number;
  printedFilePageCount?: number;
  printedFileSize?: number;
  fileAttachCount?: number;
  fileAttachPageCount?: number;
  fileAttachSize?: number;
  signFileAttachCount?: number;
  signFileAttachPageCount?: number;
  signFileAttachSize?: number;
  signFileAttachRate?: number;
  notArchivingFileCount?: number;
  notArchivingFilePageCount?: number;
  notArchivingFileSize?: number;
  notArchivingFileAttachCount?: number;
  notArchivingFileAttachPageCount?: number;
  notArchivingFileAttachSize?: number;
  printedFileAttachPageCount?: number;
  printedFileAttachCount?: number;
  printedFileAttachSize?: number;
  printedZipFileId?: string;
  // 前端自用
  fileRealCount?: number;
}
